import { render, staticRenderFns } from "./WrongProductSelectedDialog.vue?vue&type=template&id=48772ef8&scoped=true"
import script from "./WrongProductSelectedDialog.vue?vue&type=script&lang=js"
export * from "./WrongProductSelectedDialog.vue?vue&type=script&lang=js"
import style0 from "./WrongProductSelectedDialog.vue?vue&type=style&index=0&id=48772ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48772ef8",
  null
  
)

export default component.exports